// Generic "Verify Property/Entity" dialog, reused by both propertiesTab.tsx
// and entitiesTab.tsx with a different title and source-option list.
import { useEffect, useState } from 'react';
import { FormControl, Grid, Select, TextField, Typography } from '@material-ui/core';
import { Button, StandardDialog } from '@roc/ui';
import { useCenteredDialogStyles } from './centeredDialogStyles';

export const VerifyRecordDialog = ({
  open,
  title,
  recordLabel,
  sourceOptions,
  onClose,
  onConfirm,
}: {
  open: boolean;
  title: string;
  recordLabel: string;
  sourceOptions: string[];
  onClose: () => void;
  onConfirm: (verificationSource: string, othersReason: string) => void;
}) => {
  const dialogClasses = useCenteredDialogStyles();
  const [verificationSource, setVerificationSource] = useState('');
  const [othersReason, setOthersReason] = useState('');

  useEffect(() => {
    if (open) {
      setVerificationSource('');
      setOthersReason('');
    }
  }, [open]);

  const confirmDisabled = !verificationSource || (verificationSource === 'Other' && !othersReason);

  return (
    <StandardDialog
      classes={{ paper: dialogClasses.paper, container: dialogClasses.container }}
      open={open}
      maxWidth="sm"
      title={title}
      handleClose={onClose}
      dialogContent={
        <Grid container direction="column">
          <Grid>
            <Typography variant="body1" style={{ marginBottom: 25 }}>
              What is the verification source?
              <FormControl style={{ marginLeft: 10, position: 'relative', bottom: 3, marginRight: 5 }}>
                <Select value={verificationSource} native onChange={(event) => setVerificationSource(event.target.value as string)}>
                  <option aria-label="None" value="" />
                  {sourceOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Typography>
            {verificationSource === 'Other' && (
              <>
                <Typography>Please specify:</Typography>
                <FormControl style={{ width: '100%', marginBottom: 16, paddingRight: 64 }}>
                  <TextField
                    variant="outlined"
                    value={othersReason}
                    onChange={(event) => setOthersReason(event.target.value)}
                  />
                </FormControl>
              </>
            )}
            <Typography variant="body1">Are you sure you want to mark this {recordLabel} as verified?</Typography>
          </Grid>
        </Grid>
      }
      dialogActions={
        <Grid container direction="row" justifyContent="flex-end">
          <Button testId="cancelVerifyRecord" style={{ marginRight: 10 }} onClick={onClose}>
            Cancel
          </Button>
          <Button
            testId="confirmVerifyRecord"
            disabled={confirmDisabled}
            color="primary"
            variant="outlined"
            onClick={() => onConfirm(verificationSource, othersReason)}
          >
            Verify
          </Button>
        </Grid>
      }
    />
  );
};
